import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import {
  loadBlog,
  selectBlogCategories,
  selectBlogPosts,
} from '../../utils/redux/store/blog';
import { loadHeros, selectHero } from '../../utils/redux/store/heros';
import { useLocale } from '../../../features/src/i18n';
import { getContentfulLocale } from '../../../features/src/i18n/locales';
import { CategoryObject } from './types';

// Define a custom hook to encapsulate the Redux logic
export const useReduxBlog = () => {
  const dispatch = useDispatch();
  const locale = useLocale();
  useEffect(() => {
    dispatch(loadHeros());
  });

  const hero = useSelector(selectHero);
  const blogPosts = useSelector(selectBlogPosts);
  const blogCategories = useSelector(selectBlogCategories);
  const [loadingMore, setLoadingMore] = useState(false);

  const loadMore = useCallback(
    async (category: CategoryObject) => {
      setLoadingMore(true);
      try {
        await dispatch(
          loadBlog({
            category: category.urlSlug,
            smartlingLanguage: getContentfulLocale(locale),
            offset: category.offset + 10,
          }),
        );
      } catch (error) {
        throw error;
      } finally {
        setLoadingMore(false);
      }
    },
    [dispatch, locale],
  );

  return { hero, blogPosts, blogCategories, loadMore, loadingMore };
};
